export default "__VITE_ASSET__BucOMqf___"